import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const ConnectionIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Icon">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.3345 3.66553C14.4632 1.79427 11.4293 1.79427 9.55803 3.66553L8.96878 4.25479C8.7247 4.49886 8.7247 4.89459 8.96878 5.13867C9.21285 5.38275 9.60858 5.38275 9.85266 5.13867L10.4419 4.54941C11.825 3.16631 14.0675 3.16631 15.4506 4.54941C16.8337 5.93252 16.8337 8.17498 15.4506 9.55809L14.0454 10.9632C12.7875 12.2212 10.748 12.2212 9.49004 10.9632L9.2634 10.7366C9.01933 10.4925 8.6236 10.4925 8.37952 10.7366C8.13544 10.9807 8.13544 11.3764 8.37952 11.6205L8.60616 11.8471C10.3523 13.5932 13.1832 13.5932 14.9293 11.8471L16.3345 10.442C18.2057 8.57071 18.2057 5.53679 16.3345 3.66553ZM5.9542 9.03673C7.21214 7.77879 9.25166 7.77879 10.5096 9.03673L10.7362 9.26336C10.9803 9.50744 11.376 9.50744 11.6201 9.26336C11.8642 9.01929 11.8642 8.62356 11.6201 8.37948L11.3935 8.15284C9.64739 6.40675 6.81641 6.40675 5.07031 8.15284L3.66516 9.55799C1.7939 11.4293 1.7939 14.4632 3.66517 16.3344C5.53643 18.2057 8.57034 18.2057 10.4416 16.3344L11.0309 15.7452C11.2749 15.5011 11.2749 15.1054 11.0309 14.8613C10.7868 14.6172 10.3911 14.6172 10.147 14.8613L9.55772 15.4505C8.17461 16.8337 5.93216 16.8337 4.54905 15.4505C3.16594 14.0674 3.16594 11.825 4.54905 10.4419L5.9542 9.03673Z"
          fill="#22282F"
        />
      </g>
    </SvgIcon>
  )
}
